import mockGroups from './mockGroups';

// Hilfsfunktionen für Datum/Zeit/Status
const days = ["2024-07-15", "2024-07-16", "2024-07-17"];
const halls = ["Halle 1", "Halle 2"];
const statuses = ["pending", "active", "completed"];

// Startzeiten pro Halle (jeweils 09:00 Uhr)
const hallStartTimes = {
  "Halle 1": 9 * 60, // Minuten ab 00:00
  "Halle 2": 9 * 60
};

// Schrittweite zwischen Events (in Minuten)
const eventStep = 45;

// Hilfsfunktion zum Formatieren von Minuten in HH:MM
function formatTime(minutes) {
  const h = Math.floor(minutes / 60).toString().padStart(2, '0');
  const m = (minutes % 60).toString().padStart(2, '0');
  return `${h}:${m}`;
}

// Generiere Events
const generateMockSchedule = () => {
  let eventId = 1;
  let hallTimes = { ...hallStartTimes };
  let hallDayIndex = { "Halle 1": 0, "Halle 2": 0 };

  return mockGroups.map((group, idx) => {
    // Abwechselnd Halle 1 und Halle 2
    const hall = halls[idx % halls.length];
    // Tag rotierend
    const dayIdx = hallDayIndex[hall] % days.length;
    const date = days[dayIdx];
    // Start- und Endzeit
    const startMinutes = hallTimes[hall];
    const endMinutes = startMinutes + eventStep;
    const time = formatTime(startMinutes);
    const endTime = formatTime(endMinutes);
    // Status zufällig
    const status = statuses[Math.floor(Math.random() * statuses.length)];

    // Event-Name
    const eventName = `${group.category} - ${group.ageGroup} - ${group.gender === 'männlich' ? 'Männer' : 'Frauen'}`;

    // Event-Objekt
    const event = {
      id: eventId++,
      date,
      time,
      endTime,
      category: group.category,
      event: eventName,
      location: hall,
      participants: group.currentParticipants,
      status,
      ageGroup: group.ageGroup,
      gender: group.gender.charAt(0).toUpperCase() + group.gender.slice(1),
      groupId: group.id,
      categoryType: group.categoryType,
      isGroupPerformance: group.isGroupPerformance || false
    };

    // Zeit für nächste Gruppe in dieser Halle erhöhen
    hallTimes[hall] += eventStep;
    // Wenn der Tag voll ist (z.B. nach 8 Events), auf nächsten Tag wechseln
    if (hallTimes[hall] >= 17 * 60) { // 17:00 Uhr
      hallTimes[hall] = 9 * 60;
      hallDayIndex[hall]++;
    }

    return event;
  });
};

const mockSchedule = generateMockSchedule();

export default mockSchedule; 